/**
 * 简体中文翻译
 * Simplified Chinese Translation
 */

const zhCNTranslations = {
  // 应用基础信息
  app: {
    title: '牛马摆烂工具',
    subtitle: '加班时间管理系统',
    description: '专业的加班时间记录与调休管理工具'
  },

  // 日期时间相关
  dateTime: {
    invalidDate: '无效日期',
    formatError: '日期格式错误'
  },
  
  // 通用词汇
  common: {
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    copy: '复制',
    close: '关闭',
    loading: '加载中...',
    success: '成功',
    error: '错误',
    warning: '警告',
    info: '信息',
    yes: '是',
    no: '否',
    ok: '好的',
    back: '返回',
    next: '下一步',
    previous: '上一步',
    submit: '提交',
    reset: '重置',
    clear: '清空',
    search: '搜索',
    filter: '筛选',
    sort: '排序',
    export: '导出',
    import: '导入',
    settings: '设置',
    help: '帮助',
    about: '关于',
    days: '天',
    confirmAdd: '确认添加',
    confirmRequest: '确认申请'
  },
  
  // 时间相关
  time: {
    startTime: '开始时间',
    endTime: '结束时间',
    duration: '时长',
    totalTime: '总时长',
    remainingTime: '剩余时间',
    usedTime: '已用时间',
    availableTime: '可用时间',
    hours: '小时',
    minutes: '分钟',
    days: '天',
    today: '今天',
    yesterday: '昨天',
    thisWeek: '本周',
    thisMonth: '本月',
    thisYear: '本年',
    to: '至',
    total: '共'
  },
  
  // 加班相关
  overtime: {
    title: '加班记录',
    record: '录入加班',
    startTime: '牛马开始时间',
    endTime: '牛马结束时间',
    duration: '加班时长',
    remaining: '剩余可摆烂时间',
    total: '总加班时间',
    list: '加班记录列表',
    details: '详细记录',
    consumption: '消耗记录',
    edit: '编辑加班记录',
    delete: '删除加班记录',
    copy: '复制记录',
    
    // 表单验证
    validation: {
      startTimeRequired: '请输入牛马的开始时间！',
      endTimeRequired: '请输入牛马的结束时间！',
      endTimeAfterStart: '牛马结束时间必须大于开始时间！'
    },
    
    // 统计信息
    stats: {
      totalHours: '本年度您已经牛马了 {{hours}} 小时',
      remainingHours: '剩余可摆烂时间 {{overtimeHours}}+{{annualLeaveHours}} 小时'
    }
  },
  
  // 调休相关
  rest: {
    title: '摆烂记录',
    record: '申请摆烂',
    startTime: '摆烂开始时间',
    endTime: '摆烂结束时间',
    duration: '摆烂时长',
    type: '摆烂类型',
    compTime: '调休',
    list: '摆烂记录列表',
    edit: '编辑摆烂记录',
    delete: '删除摆烂记录',
    
    // 表单验证
    validation: {
      startTimeRequired: '请输入摆烂开始时间和结束时间！',
      endTimeRequired: '请输入摆烂结束时间！',
      endTimeAfterStart: '摆烂结束时间必须大于开始时间！',
      insufficientTime: '剩余时间不足以申请这么多摆烂时间！',
      insufficientOvertimeTime: '剩余牛马时间不足以增加这么多调休时间！'
    }
  },
  
  // 年假相关
  annualLeave: {
    title: '年假管理',
    totalDays: '年假总天数',
    usedHours: '已用小时',
    remainingHours: '剩余小时',
    record: '年假记录',
    set: '设置年假',
    edit: '编辑年假记录',
    delete: '删除年假记录',
    
    // 设置对话框
    settings: {
      title: '设置年假',
      totalDaysLabel: '年假总天数',
      totalDaysPlaceholder: '请输入年假总天数',
      note: '注意：年假按每天8小时计算'
    }
  },
  
  // 计算规则
  rules: {
    title: '计算规则说明',
    overtime: {
      title: '加班计算规则',
      description: '按连续时间计算，包含午休时间',
      example: '例如：{{timeRange}} = {{result}}',
      note: '加班时间按实际连续时间计算，不扣除午休'
    },
    rest: {
      title: '调休计算规则',
      description: '按工作日计算，扣除午休时间',
      example: '例如：{{timeRange}} = {{result}}（{{note}}）',
      note: '扣除1小时午休',
      workingHours: '工作时间：9:00-18:00（扣除12:00-13:00午休）'
    },
    annualLeave: {
      title: '年假计算规则',
      description: '年假按每天8小时计算',
      example: '1天年假 = 8小时'
    }
  },
  
  // 数据管理
  data: {
    save: '保存数据到本地',
    load: '加载备份数据',
    export: '导出数据',
    import: '导入数据',
    backup: '备份数据',
    restore: '恢复数据',
    clear: '清空数据',
    
    // 消息提示
    messages: {
      saveSuccess: '数据保存成功',
      loadSuccess: '数据已成功导入并更新',
      exportSuccess: '数据导出成功',
      importSuccess: '数据导入成功',
      clearSuccess: '数据清空成功',
      parseError: '无法解析导入的文件。请确保它是有效的格式。',
      newerDataWarning: '导入的数据比本地存的数据旧。是否仍要覆盖本地数据？',
      cleanupComplete: '清理完成，共移除 {{count}} 条冗余记录。'
    }
  },
  
  // 表格相关
  table: {
    index: '序号',
    number: '序号',
    type: '类型',
    startTime: '开始时间',
    endTime: '结束时间',
    duration: '总时长',
    remaining: '剩余时间',
    remainingTime: '剩余可摆烂时间',
    actions: '操作',
    details: '详细记录',
    expand: '展开',
    collapse: '收起',
    noData: '暂无数据',
    consumptionRecords: '摆烂消耗记录',
    restRequestStartTime: '摆烂申请开始时间',
    restRequestEndTime: '摆烂申请结束时间',
    actualConsumptionStartTime: '实际消耗开始时间',
    actualConsumptionEndTime: '实际消耗结束时间',
    deductionTime: '摆烂扣除时间',
    annualLeaveStartTime: '年假开始时间',
    annualLeaveEndTime: '年假结束时间',

    // 分页
    pagination: {
      total: '共 {{total}} 条',
      pageSize: '每页显示',
      items: '条',
      page: '页'
    }
  },
  
  // 消费记录
  consumption: {
    title: '摆烂消耗记录',
    restStartTime: '摆烂申请开始时间',
    restEndTime: '摆烂申请结束时间',
    actualStartTime: '实际消耗开始时间',
    actualEndTime: '实际消耗结束时间',
    deductionTime: '摆烂扣除时间',
    type: '类型',
    
    // 复制报告
    copyReport: {
      overtimeDeduction: '扣除对应加班时间共（{{hours}}小时）',
      annualLeaveDeduction: '扣除年假时间共（{{hours}}小时）',
      copySuccess: '已复制到剪贴板',
      copyFailed: '复制失败，请重试'
    }
  },
  
  // 更新日志
  updateLog: {
    title: '更新记录',
    show: '显示更新记录',
    hide: '隐藏更新记录',
    version: '版本',
    date: '日期',
    content: '更新内容'
  },
  
  // 统计信息
  stats: {
    totalOvertime: '累计牛马时间',
    availableOvertime: '可用牛马时间',
    remainingAnnualLeave: '剩余牛马大时间',
    totalRest: '已摆烂时间'
  },

  // 操作按钮
  actions: {
    recordOvertime: '记录牛马事件',
    addOvertimeTime: '添加牛马记录',
    requestRest: '申请摆烂',
    useOvertimeTime: '开始摆烂~~',
    setAnnualLeave: '设置牛马大时间',
    configureAnnualLeaveDays: '配置年度牛马大时间',
    recordAnnualLeave: '记录牛马大时间',
    saveData: '保存牛马记录',
    exportData: '导出牛马记录',
    importData: '导入牛马记录',
    cleanData: '清理重复牛马记录'
  },

  // 消息提示
  messages: {
    overtimeAdded: '牛马记录已添加',
    restAdded: '摆烂记录已添加',
    overtimeDeleted: '牛马记录已删除',
    restDeleted: '摆烂记录已删除',
    dataSaved: '数据已保存',
    dataLoaded: '数据已加载',
    dataImported: '数据已导入',
    dataExported: '数据已导出',
    noLocalData: '没有找到本地数据，使用默认数据',
    cleanupComplete: '清理完成，移除了 {{count}} 条冗余记录',
    editFeatureComingSoon: '编辑功能将在后续版本中完善',
    overtimeRecordAdded: '牛马记录添加成功！',
    restRequestSubmitted: '摆烂申请提交成功！',
    pleaseCompleteTimeInfo: '请填写完整的时间信息',
    overtimeRecordUpdated: '牛马记录更新成功！',
    restRecordUpdated: '摆烂记录更新成功！',
    annualLeaveRecordUpdated: '牛马大时间记录更新成功！',
    annualLeaveRecordAdded: '牛马大时间记录添加成功！',
    copiedToClipboard: '已复制到剪贴板',
    copyFailed: '复制失败，请重试'
  },

  // 模态框
  modals: {
    recordOvertimeTitle: '记录牛马事件',
    requestRestTitle: '摆烂申请表',
    setAnnualLeaveTitle: '🏖️ 设置牛马大时间',
    recordOvertimeTimeTitle: '⏱️ 记录牛马时间',
    requestRestTimeTitle: '😴 申请摆烂时间',
    editOvertimeTitle: '修改牛马记录',
    editRestTitle: '修改摆烂记录',
    editAnnualLeaveTitle: '修改牛马大时间记录',
    recordAnnualLeaveTitle: '🏖️ 记录牛马大时间',
    editRecordTitle: '编辑记录'
  },

  // 表单
  forms: {
    currentAnnualLeave: '当前牛马大时间：',
    remainingTime: '剩余大时间：',
    noAnnualLeave: '无牛马大时间',
    customDays: '自定义大时间：',
    enterDays: '输入大时间',
    description: '备注：',
    descriptionPlaceholder: '可选的备注信息',
    annualLeaveStartTime: '大时间开始时间:',
    annualLeaveEndTime: '大时间结束时间:',
    overtimeStartTime: '牛马开始时间:',
    overtimeEndTime: '牛马结束时间:'
  },

  // 确认对话框
  confirmDialog: {
    deleteMessage: '确定要删除这条记录吗？',
    deleteRestMessage: '确定要删除这条摆烂记录？',
    deleteAnnualLeaveMessage: '确定要删除这条年假记录吗？',
    cleanupMessage: '确定要清理冗余数据吗？此操作不可撤销。'
  },

  // 语言设置
  language: {
    title: '语言设置',
    current: '当前语言',
    select: '选择语言',
    change: '切换语言'
  },

  // 记录相关
  records: {
    overtimeRecords: '牛马记录',
    restRecords: '摆烂记录',
    annualLeaveRecords: '大时间记录',
    restType: '调休',
    annualLeaveType: '牛马大时间',
    annualLeave: '牛马大时间',
    rest: '摆烂',
    overtime: '牛马'
  },

  // 分页相关
  pagination: {
    previous: '上一页',
    next: '下一页',
    pageInfo: '第 {{current}} 页，共 {{total}} 页',
    itemsPerPage: '{{count}}条/页'
  },

  // 复制功能
  copy: {
    deductOvertimeTotal: '加班调休,扣除对应加班时间共（{{hours}}小时）',
    deductAnnualLeaveTotal: '扣除年假时间共（{{hours}}小时）',
    annualLeaveTitle: '年假休假:',
    errorPrefix: '无法复制文本: '
  },

  // 错误信息
  errors: {
    networkError: '网络错误，请检查网络连接',
    serverError: '服务器错误，请稍后重试',
    unknownError: '未知错误，请联系管理员',
    validationError: '数据验证失败',
    permissionDenied: '权限不足',
    notFound: '未找到相关数据',
    timeout: '请求超时，请重试'
  },

  // 主题相关
  theme: {
    toggle: '切换主题',
    modern: '现代风格',
    retro: '红白机风格',
    sketch: '手绘风格',
    damaged: '战损崩坏风',
    switchToModern: '切换到现代风格',
    switchToRetro: '切换到红白机风格',
    switchToSketch: '切换到手绘风格',
    switchToDamaged: '切换到战损崩坏风'
  }
};

export default zhCNTranslations;
